module.exports = __webpack_public_path__ + "ups-pickup.571e8494a56caecefab62e16c12a7a5a.svg";